// SPDX-License-Identifier: AGPL-3.0-or-later

import {GenericErrorModal} from '@app/features/app/components/alerts/GenericErrorModal';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
export const InvitesLoadFailedModal = observer(() => {
	const {t} = useLingui();
	return (
		<GenericErrorModal title={t`Failed to Load Invites`} message={t`We couldn't load the invites at this time.`} />
	);
});
